exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scope-contains-ckeditor[data-v-3d42de58]{min-height:10rem}.scoped-editor-row[data-v-3d42de58]:before{border-top:1px solid #dedede;width:95%;margin:.5rem auto;display:block}", ""]);

// exports
